import React from 'react';
import { LayoutIcon, InheritProps } from './Layout';

export function SpotlightIcon(props: InheritProps) {
  return (
    <LayoutIcon
      {...props}
      childrenRender={(color: string) => (
        <svg
          width='100%'
          height='100%'
          viewBox='0 0 100 100'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='xMidYMid meet'
        >
          <rect
            x='1.5'
            y='1.5'
            width='97'
            height='97'
            rx='8.5'
            fill='#343434'
            stroke={color}
            strokeWidth='3'
          />
          <path
            d='M10.6553 41.5247C10.6553 39.8679 11.9984 38.5247 13.6553 38.5247H30.6061C32.2629 38.5247 33.6061 39.8679 33.6061 41.5247V58.4755C33.6061 60.1324 32.2629 61.4755 30.6061 61.4755H13.6553C11.9984 61.4755 10.6553 60.1324 10.6553 58.4755V41.5247Z'
            fill='#D9D9D9'
          />
          <path
            d='M38.5713 35.8571C38.5713 34.2003 39.9144 32.8571 41.5713 32.8571H58.4284C60.0853 32.8571 61.4284 34.2003 61.4284 35.8571V64.1428C61.4284 65.7997 60.0853 67.1428 58.4284 67.1428H41.5713C39.9144 67.1428 38.5713 65.7997 38.5713 64.1428V35.8571Z'
            fill='#D9D9D9'
          />
          <path
            d='M66.3936 41.5247C66.3936 39.8679 67.7367 38.5247 69.3936 38.5247H86.3444C88.0012 38.5247 89.3444 39.8679 89.3444 41.5247V58.4755C89.3444 60.1324 88.0012 61.4755 86.3444 61.4755H69.3936C67.7367 61.4755 66.3936 60.1324 66.3936 58.4755V41.5247Z'
            fill='#D9D9D9'
          />
        </svg>
      )}
    />
  );
}
